// @flow
import * as React from "react";
import PropTypes from 'prop-types';
import {reisy, use} from "reisy";
import {observer} from "mobx-react";
import {injectIntl, defineMessages} from 'react-intl';

import type {Publishable} from "../api/types.js";
import {post} from "../xhr.js";
import Navigation from "../navigation/index.js";
import Footer from "../components/footer.js";
import Heading from '../components/heading';

const messages = defineMessages({
	passwordPlaceholder: {
		id: 'passwordScreen.passwordPlaceholder',
		defaultMessage: 'password',
	},
	usernamePlaceholder: {
		id: 'passwordScreen.usernamePlaceholder',
		defaultMessage: 'username',
	},
	subTitle: {
		id: 'passwordScreen.subTitle',
		defaultMessage: 'is a protected {type, select, story {story} collection {collection}}',
	},
	submit: {
		id: 'passwordScreen.submit',
		defaultMessage: 'submit',
	},
	error: {
		id: 'passwordScreen.error',
		defaultMessage: 'Authorization not possible!',
	},
});

const styles = reisy`
@namespace PasswordScreen;

showBack: true;
showShare: false;
showFooter: false;
JackInTheBox: $Settings.JackInTheBox;

Container {
	@extends Helpers.Fullscreen;
	display: flex;
	flex-direction: column;
	min-height: 100vh;
}
Contain {
	@extends Helpers.Contain;
	@extends Helpers.FontSize;
}
Wrapper {
	display: flex;
	justify-content: space-around;
	align-items: center;
	width: 100%;
	flex-grow: 1;
	text-align: center;
}
FormBox {
	width: 100%;
	max-width: 400px;
	height: auto;
}
FormTitle {
	font-family: $Fonts.title;
	color: $Colors.TextDark;
	font-weight: bold;
	margin: 0;
}
FormSubTitle {
	font-family: $Fonts.subtitle;
	color: $Colors.TextDark;
	font-weight: normal;
	margin: 0;
}
Input {
	display: block;
	width: 80%;
	margin: 2em auto;
	font-size: 1em;
	padding: .5em;
	text-align: center;
	border: 0;
	border-bottom: 1px solid #000;
	-webkit-appearance: none;
	outline: none;
	font-family: $Fonts.text;

	&[data-error] {
		border-color: #c00;

		&::placeholder {
			color: #c00;
		}
	}
}
Button {
	font-weight: normal;
	text-decoration: none;
	display: inline-block;
	padding: .5em 1em;
	color: inherit;
	border: 1px solid #000;
	font-family: $Fonts.aside;
	font-size: 0.875em;
	cursor: pointer;
	background: #fff;
}
Error {
	color: #c00;
	font-weight: bold;
	margin-top: 2em;
	font-family: $Fonts.text;
}
`;

type Props = {
	content: Publishable;
	intl: any;
};

class PasswordScreen extends React.Component {
	static contextTypes = {
		player: PropTypes.object,
	};

	constructor() {
		super();

		this.state = {
			error: null,
			passwordError: null,
			usernameError: null,
		}
	}

	sendAuth(data) {
		this.setState({error: null});
		post(this.context.player.api._API_BASE + `api/v1/publishers/${this.props.content.publisher.id}/auth/`, data)
			.then(result => {
				window.location.reload();
			}).catch(e => {
				let error = this.props.intl.formatMessage(messages.error);
				let passwordError = null;
				let usernameError = null;
				if (e.xhr && e.xhr.response) {
					const response = JSON.parse(e.xhr.response);
					if (response['non_field_errors']) {
						error = response['non_field_errors'].join(' ');
					}
					if (response.password) {
						error = '';
						passwordError = response.password;
					}
					if (response.username) {
						error = '';
						usernameError = response.username;
					}
				}
				this.setState({
					error,
					usernameError,
					passwordError,
				});
			});
	}

	handleSubmit = e => {
		this.sendAuth({
			publishable_id: this.props.content.id, 
			password: this.passwordInput.value, 
			username: this.usernameInput.value,
		}); 
		e.preventDefault();
	}

	render() {
	 	const {content, intl: {formatMessage}} = this.props;

	 	return (
			<div {...use(styles.Container, styles.JackInTheBox && styles.Contain)}>
				<Navigation styles={styles} />
				<div {...use(styles.Wrapper)}>
					<form {...use(styles.FormBox)} onSubmit={this.handleSubmit} method="post">
						<Heading lvl={1} {...use(styles.FormTitle)}>{content.title}</Heading>
						<p {...use(styles.FormSubTitle)}>{formatMessage(messages.subTitle, {type: content.type})}</p>
						{this.state.error ? <div {...use(styles.Error)}>{this.state.error}</div> : null}
						<input {...use(styles.Input)} type="text" placeholder={formatMessage(messages.usernamePlaceholder)} name="username" ref={ref => this.usernameInput = ref} onKeyDown={e => e.nativeEvent.stopImmediatePropagation()} data-error={this.state.usernameError} />
						<input {...use(styles.Input)} type="password" placeholder={formatMessage(messages.passwordPlaceholder)} name="password" ref={ref => this.passwordInput = ref} onKeyDown={e => e.nativeEvent.stopImmediatePropagation()} data-error={this.state.passwordError}  />
						<input {...use(styles.Button)} type="submit" value={formatMessage(messages.submit)} />
					</form>
				</div>
				{styles.showFooter && <Footer publisher={content.publisher} />}
			</div>
		);	
	}
} 

export default injectIntl(observer(PasswordScreen));



// WEBPACK FOOTER //
// ./lib/screens/password.js